<template>
	<div class="mr-2 mw-320px">
		<h5 class="text-white text-lg font-bold mb-3">{{ name }}</h5>
		<span class="errormessage" :class="{ 'opacity-100': $page.props.errors[type] }"
		>{{ $page.props.errors[type] }}</span>
		<RecommendedAspectRatio :uploadBoxType="uploadPlace" />
		<div v-if="!form.tour_files[type].loaded_file_path" class="upload-box">
		    <span>
		    	<i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState(type)">{{ __('media.select-from-library') }}</a>
		    </span>
		</div>

		<div v-if="form.tour_files[type].loaded_file_path" class="upload-box relative">
            <div class="">
                <img :src="form.tour_files[type].loaded_file_path" class="logo-img object-cover w-full h-full">
            </div>

            <div class="badge-buttons-wrapper">
	            <div class="badge-buttons shadow">
	                <button @click.prevent="() => changeUploadBoxState(type)"
	                title="Edit"><i class="pen"></i></button>
	                <button @click.prevent="() => deletePreviewImageOrLogo(type, 'tour')"
	                title="Delete"><i class="trash"></i></button>
	            </div>
	        </div>

        </div>

	</div>
</template>

<script>
import RecommendedAspectRatio from '@/Pages/Media/RecommendedAspectRatio';
import { __ } from '@/locale'
import {
	deletePreviewImageOrLogo,
	hasFileInNotFallbackLanguage,
	unlinkImageOrLogoInAllLanguages,
	unlinkImageOrLogoByLanguage,
	deleteInAllLanguagesFormRunning
} from '@/Pages/GlobalHelpers';

export default {
	components: {
        RecommendedAspectRatio
    },
	props: [
		'name',
		'type',
		'form',
		'file',
		'changeUploadBoxState',
		'uploadPlace',
		'current_language',
		'changeLanguage',
		'showPreventFallbackLangModal',
		'deleteInAllLanguagesFormRunning',
		'hidePreventFallbackLangModal'
	],
    mounted() {
        // console.log('logit', {
        //     name: this.name,
        //     type: this.type,
        //     form: this.form,
        //     file: this.file,
        //     place: this.uploadPlace
        // });
    },
	data(){
		return {
			identifier: this.$page.props.tour.data.identifier,
			entity: 'tour',
			unlink_form: this.$inertia.form({
                _method: 'POST',
                type: null,
                current_language: null,

            }),
            files_for_delete_in_languages:[],
            number_of_language_for_file_to_delete: null,
            __
		}
	},
	watch:{
        deleteInAllLanguagesFormRunning:deleteInAllLanguagesFormRunning,
    },
	methods:{
		//preview image and logo
        deletePreviewImageOrLogo:deletePreviewImageOrLogo,
        hasFileInNotFallbackLanguage:hasFileInNotFallbackLanguage,
        unlinkImageOrLogoInAllLanguages:unlinkImageOrLogoInAllLanguages,
        unlinkImageOrLogoByLanguage:unlinkImageOrLogoByLanguage,
	}
}
</script>
